import { render, staticRenderFns } from "./OnRH.vue?vue&type=template&id=6bd92c64&"
import script from "./OnRH.vue?vue&type=script&lang=js&"
export * from "./OnRH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports